import { LoadStatus } from '@rematter/frontend-lib-api-client';

import { LoadsTabListItem } from '../types/load';
import { getLoadLineItems } from '../utils/loadLineItems';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadsTabListQueryAtom = createQueryAtomFactory(
  'trade.loadsTabList',
  (params: {
    bookingId?: string;
    salesOrderId?: string;
    purchaseOrderId?: string;
  }) => ({
    loads: {
      __args: {
        filter: {
          salesOrderId: params.salesOrderId,
          purchaseOrderIds: params.purchaseOrderId
            ? [params.purchaseOrderId]
            : undefined,
          bookingIds: params.bookingId ? [params.bookingId] : undefined,
        },
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      entries: {
        id: true,
        status: true,
        reviewed: true,
        documentNumber: true,
        salesOrderId: true,
        salesOrder: {
          account: {
            name: true,
          },
          shippingAddress: {
            streetAddress: true,
            city: true,
            state: true,
            postalCode: true,
          },
        },
        lineItems: {
          id: true,
          itemId: true,
          phase: true,
        },
      },
    },
  }),
  {
    select: ({
      loads,
    }): {
      loads: LoadsTabListItem[];
    } => ({
      loads: loads.entries.map((load) => {
        const { materialItemIds } = getLoadLineItems(load.lineItems ?? []);

        return {
          id: load.id,
          loadNumber: load.documentNumber.toString(),
          customerName: load.salesOrder?.account?.name,
          status: load.status as LoadStatus,
          reviewed: load.reviewed ?? false,
          shippingAddress: load.salesOrder?.shippingAddress ?? null,
          salesOrderId: load.salesOrderId ?? null,
          lineItems: load.lineItems,
          materialItemIds,
          lineItemCount: materialItemIds.length,
        };
      }),
    }),
  },
);
